module.exports = __webpack_public_path__ + "5ea69400.webp";